// Replaced by the page with the styled monthly retirement income amount.
// Some heading messages do not include the token.
export const INCOME_TOKEN = '{income}'

const ON_TRACK = `You're on-track to have ${INCOME_TOKEN} per month in retirement.`
const OFF_TRACK_PROJECTED = `You're off-track, but you're projected to have ${INCOME_TOKEN} per month in retirement.`

/**
 * Returns heading copy based on the current and displayed plans.
 * When both are off-track, the copy also reflects whether the displayed plan improves on the current plan.
 */
export function getHeadingMessage({ isModified, currentOnTrack, planOnTrack, planImproved }) {
  if (isModified) {
    if (planOnTrack) {
      return currentOnTrack
        ? ON_TRACK
        : `Your changes put you on-track to have ${INCOME_TOKEN} per month in retirement.`
    }

    if (currentOnTrack) {
      return `Your changes put you off-track, but you're projected to have ${INCOME_TOKEN} per month in retirement.`
    }

    return planImproved
      ? `Your changes didn't get you on-track, but they got you closer.`
      : OFF_TRACK_PROJECTED
  }

  if (planOnTrack) {
    return currentOnTrack
      ? ON_TRACK
      : `Let's get you on-track to have ${INCOME_TOKEN} per month in retirement.`
  }

  if (currentOnTrack) {
    return OFF_TRACK_PROJECTED
  }

  return planImproved
    ? `We weren't able to get you on-track, but a few changes will get you closer.`
    : OFF_TRACK_PROJECTED
}
